import { createTheme } from "@mui/material";
import { primarycolor, secondarycolor } from "./colors";


const theme = createTheme({
    palette: {
        primary: {
            main: primarycolor
        }
    },
    typography: {
        "fontFamily": `Century Gothic, CenturyGothic, AppleGothic, sans-serif`,
        // "fontSize": 12,
        // "fontWeightLight": 300,
        // "fontWeightRegular": 400,
        // "fontWeightMedium": 500
    }
})

export default theme